import React from "react";
import { withRouter } from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import Typography from '@material-ui/core/Typography';
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import useSessionState from "../../../state/hooks/session/useSessionState";

import logo from "../../../assets/images/logo_transp.png";

const useStyles = makeStyles(theme => ({
  drawerMargin: {
    [theme.breakpoints.up("md")]: {
      marginLeft: 60
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: 200
    }
  },
  menuButton: {
    color: theme.palette.common.white
  },
  logo: {
    maxWidth: 200,
    maxHeight: 60,
    "&:hover": {
      cursor: "pointer"
    }
  }
}));

function Private({ toggleDrawer, open, history }) {
  const { isLoggedIn, user } = useSessionState();
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Toolbar>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <img
            alt="ooPark-community"
            className={classes.logo}
            src={logo}
            onClick={() => history.push("/")}
          />
        </Grid>
        <Grid item>
          {isLoggedIn && (<Typography variant="button" display="block" >
            {user.displayName ? user.displayName : user.email} {user.role ? `(${user.role})`: undefined}
          </Typography>)}
        </Grid>
        {matches && (
          <Grid item>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                toggleDrawer();
              }}
            >
              <MenuIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </Toolbar>
  );
}

export default withRouter(Private);
